import React from 'react';
import { RootState } from '@Common/models/redux/store';
import { Badge, styled } from '@quillbot/design-system';
import { useSelector } from 'react-redux';

const StyledBadge = styled(Badge)(({ theme, overlap }) => {
  let marginTop: string;
  let marginRight: string;
  switch (overlap) {
    case 'circular':
      marginTop = '-2px';
      marginRight = '-3px';
      break;
    case 'rectangular':
      marginTop = '5px';
      marginRight = '-5px';
      break;
    default:
      marginTop = '2px';
      marginRight = '-6px';
  }
  return {
    '.MuiBadge-badge': {
      backgroundColor: '#CD323C',
      height: '10px',
      width: '10px',
      borderRadius: '25px',
      marginTop,
      marginRight,
    },
  };
});

export default function SessionExceedAlert({
  children,
  overlap,
}: {
  children: any;
  overlap?: 'circular' | 'rectangular';
}) {
  const sessionsExceeded = useSelector((rootState: RootState) => rootState.user?.sessionsExceeded);
  const hideSessionManager = useSelector((rootState: RootState) => rootState.common?.hideSessionManager);
  return (
    <StyledBadge variant="dot" color="error" invisible={!sessionsExceeded || hideSessionManager} overlap={overlap}>
      {children}
    </StyledBadge>
  );
}
